<div
  [ngClass]="[
    'cp-popover',
    'cp-popover__size--' + size,
    'cp-popover__position--' + position,
    'cp-popover__variation--' + variation,
    'cp-popover__orientation--' + orientation
  ]"
  [class.cp-popover--open]="open"
  tabindex="-1"
  (blur)="blur()"
>
  <div class="cp-popover__label" (click)="toggle($event)">
    <ng-content select="[label]"></ng-content>
  </div>
  <div class="cp-popover__pop" (click)="clickInside($event)" #container>
    <div
      class="cp-popover__pop__content"
      [class.cp-popover__pop__content--fixto-left]="isLeftOffScreen"
      [class.cp-popover__pop__content--fixto-right]="isRightOffScreen"
      #contentWrapper
    >
      <ng-content select="[content]"></ng-content>
    </div>
  </div>
</div>
